import React from "react";
import { Card, Button, CardText, Collapse, Nav } from 'react-bootstrap';
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import Auth from "./auth";
import HeroBackground from '../HeroBackground';

const PrivateRoute = ({ children }) => {

    const navigate = useNavigate();
    const location = useLocation();
  if (!Auth.loggedIn()) {
    return (
      <div className="container"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'block',
      
      }}
        
        >
      {/* <HeroBackground image="allbg.jpg"  bgColor="#131212" /> */}
          <Card className="card-body container col-10 col-md-6 justify-content-center"
           style={{ 
        textAlign: "center", 
             overflow: 'hidden',
            boxSizing: 'border-box',
            maxWidth: '400px',
            width: '100%',
            position: 'relative',
            color: 'white',
            borderRadius: '10px'
        }}
          >
            <h5
            style={{
              margin: '0px'
            }}
            >You must be logged in to access this page</h5>
            <Button
            type="button"
             onClick={() => {navigate('/Login', { state: { from: location.pathname } }); }}
               className="process-card-text hover-brighten col-12"
                  style={{
                    display: 'block',
                   
                    width: 'auto',
                    margin: '20px auto',
                    fontSize: '2.5vmin',
                    backgroundColor: 'rgb(67, 66, 66)',
                    color: '#fff',
                     border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                    borderRadius: '999px',
                    padding: '0.4rem 1rem',
                    cursor: 'pointer',
                    textAlign: 'center',
                  }}
            >
              <h5 style={{ margin: '1%' }}>Login</h5>
            </Button>
          </Card>
      </div>
    );
  }
  return children;
};

export default PrivateRoute;